import { render, staticRenderFns } from "./ShadowWebsocket.vue?vue&type=template&id=a6e96fb4&scoped=true"
import script from "./ShadowWebsocket.vue?vue&type=script&lang=js"
export * from "./ShadowWebsocket.vue?vue&type=script&lang=js"
import style0 from "./ShadowWebsocket.vue?vue&type=style&index=0&id=a6e96fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e96fb4",
  null
  
)

export default component.exports